import { render } from "./postinfo.vue?vue&type=template&id=3c1faf67"
import script from "./postinfo.vue?vue&type=script&lang=js"
export * from "./postinfo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__